

import { Navigate } from "react-router-dom";

import { useBusinessAuth } from "../../Middleware/context/BusinessContext";

const PrivateRoutebusiness = ({ children }) => {
  const {  companyProfile, loading } = useBusinessAuth();

  if (loading) return null;

  return  companyProfile ? children : <Navigate to="/Business/Login" />;
};

export default PrivateRoutebusiness;
